// extracted by mini-css-extract-plugin
export default {"Asset":"Asset_Asset__3wx2o"};